/* eslint-disable max-len */

export const fhsComponentTokens = {} as const;
